import { render, staticRenderFns } from "./PortWriteBody.vue?vue&type=template&id=b82cf314&scoped=true"
import script from "./PortWriteBody.vue?vue&type=script&lang=js"
export * from "./PortWriteBody.vue?vue&type=script&lang=js"
import style0 from "./PortWriteBody.vue?vue&type=style&index=0&id=b82cf314&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82cf314",
  null
  
)

export default component.exports